<template>
  <div class="page pcgs-page">
    <div class="maintitle">PCGS查询结果</div>
    <div v-if="loading" class="state">查询中...</div>
    <div v-else-if="error" class="state error">{{ error }}</div>
    <template v-else-if="data">
      <div class="summary">
        <div class="summary-title">送评表号：{{ field(['SubmissionNo', 'SubmissionNumber'], submissionNo) }}</div>
        <div class="summary-grid">
          <div><span>PCGS订单号</span><strong>{{ field(['OrderNo', 'OrderNumber'], '暂无') }}</strong></div>
          <div><span>订单状态</span><strong>{{ field(['OrderStatus', 'Status', 'StatusDescription'], '处理中') }}</strong></div>
          <div><span>接收日期</span><strong>{{ date(field(['ReceivedDate', 'DateReceived', 'ReceivedAt'], '暂无')) }}</strong></div>
          <div><span>返还日期</span><strong>{{ date(field(['DateShipped', 'ReturnDate', 'ReturnedDate', 'ReturnAt'], '暂无')) }}</strong></div>
        </div>
      </div>
      <div class="list-title">钱币明细</div>
      <div v-if="products.length" class="table-frame">
        <div class="table-header-sticky">
          <div ref="tableHeaderScroll" class="table-header-scroll">
            <table class="products-table">
              <colgroup>
                <col class="col-line">
                <col class="col-item">
                <col class="col-cert">
                <col class="col-pcgs">
                <col class="col-description">
                <col class="col-grade">
              </colgroup>
              <thead>
                <tr>
                  <th>序号</th>
                  <th>产品号</th>
                  <th>证书号</th>
                  <th>PCGS号</th>
                  <th>描述</th>
                  <th>评级</th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
        <div ref="tableScroll" class="table-scroll" role="region" aria-label="钱币明细表，可横向滚动" tabindex="0" @scroll="updateScrollbar">
          <table class="products-table">
            <colgroup>
              <col class="col-line">
              <col class="col-item">
              <col class="col-cert">
              <col class="col-pcgs">
              <col class="col-description">
              <col class="col-grade">
            </colgroup>
            <tbody>
              <tr v-for="(item, index) in products" :key="index">
                <td>{{ productField(item, ['LineNo', 'LineNumber', 'RowNumber'], index + 1) }}</td>
                <td>{{ productField(item, ['ItemNo', 'ProductNo', 'ProductNumber'], '暂无') }}</td>
                <td>{{ progressField(item, ['CertNo', 'CertificateNo', 'CertificateNumber']) }}</td>
                <td>{{ progressField(item, ['PCGSNo', 'PCGSNumber']) }}</td>
                <td class="description-cell">{{ productField(item, ['Description', 'Desc'], '暂无') }}</td>
                <td>{{ progressField(item, ['DisplayGrade', 'Grade', 'GradeDescription', 'Rating']) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-show="scrollbars.hasX" class="scrollbar scrollbar-x" aria-hidden="true">
          <span :style="{ width: scrollbars.xSize + '%', left: scrollbars.xOffset + '%' }"></span>
        </div>
      </div>
      <div v-else class="state">暂无钱币明细，评级完成后会更新结果。</div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.pcgs-page { height: auto; min-height: 100vh; box-sizing: border-box; background: #f5f5f5; padding-bottom: calc(100px + env(safe-area-inset-bottom)); }
.maintitle { font-size: 20px; margin: 20px; }
.summary { margin: 0 15px 15px; padding: 15px; background: #fff; border-radius: 4px; }
.summary-title { font-size: 16px; font-weight: 500; padding-bottom: 12px; border-bottom: 1px solid #eee; }
.summary-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px 12px; padding-top: 14px; }
.summary-grid span { display: block; color: #888; font-size: 13px; margin-bottom: 4px; }
.summary-grid strong { color: #333; font-size: 14px; word-break: break-word; }
.list-title { padding: 0 15px; margin: 20px 0 8px; color: #666; }
.table-frame { position: relative; margin: 0 15px 15px; padding: 0 10px 10px 0; overflow: visible; background: #fff; border-radius: 4px; }
.table-header-sticky { position: sticky; top: 0; z-index: 2; overflow: hidden; background: #fafafa; }
.table-header-scroll { overflow: hidden; }
.table-scroll { overflow-x: scroll; overflow-y: hidden; -webkit-overflow-scrolling: touch; overscroll-behavior-x: contain; scrollbar-width: none; }
.table-scroll::-webkit-scrollbar { width: 0; height: 0; }
.products-table { width: 100%; min-width: 580px; border-collapse: collapse; table-layout: fixed; color: #333; font-size: 14px; }
.products-table th, .products-table td { padding: 12px 8px; border-bottom: 1px solid #eee; text-align: left; vertical-align: top; white-space: nowrap; }
.products-table th { background: #fafafa; color: #666; font-size: 13px; font-weight: 500; }
.products-table tbody tr:last-child td { border-bottom: 0; }
.products-table .col-line { width: 52px; }
.products-table .col-item { width: 68px; }
.products-table .col-cert { width: 100px; }
.products-table .col-pcgs { width: 92px; }
.products-table .col-description { width: 180px; }
.products-table .col-grade { width: 88px; }
.products-table .description-cell { white-space: normal; word-break: break-word; }
.scrollbar { position: absolute; background: #e5e5e5; border-radius: 3px; pointer-events: none; }
.scrollbar span { position: absolute; display: block; background: #999; border-radius: 3px; }
.scrollbar-x { right: 10px; bottom: 2px; left: 3px; height: 6px; }
.scrollbar-x span { top: 0; min-width: 24px; height: 6px; }
.state { padding: 60px 20px; text-align: center; color: #888; }
.error { color: #e02f21; }
</style>

<script>
export default {
  data () { return { shop_id: null, loading: true, error: '', data: null, submissionNo: '', products: [], scrollbars: { hasX: false, xSize: 100, xOffset: 0 } } },
  created () { this.submissionNo = this.$route.query.submissionNo; this.shop_id = this.$route.params.shop_id; this.query() },
  mounted () { window.addEventListener('resize', this.updateScrollbar) },
  beforeDestroy () { window.removeEventListener('resize', this.updateScrollbar) },
  methods: {
    async query () {
      if (!this.submissionNo) { this.loading = false; this.error = '缺少PCGS订单号'; return }
      const r = await this.$axios.post('/service/queryPcgs', { submissionNo: this.submissionNo })
      this.loading = false
      if (r.status !== 1) { this.error = r.msg || '查询失败，请稍后重试'; return }
      this.data = r.data
      this.submissionNo = r.submissionNo
      const source = Array.isArray(this.data.Orders) ? this.data.Orders[0] : (Array.isArray(this.data) ? this.data[0] : this.data)
      if (source && Array.isArray(source.OrderLines)) this.products = source.OrderLines
      else {
        const keys = ['OrderDetails', 'OrderDetail', 'OrderItems', 'Products', 'Items', 'SubmissionItems']
        const key = source && Object.keys(source).find(name => keys.some(item => name.toLowerCase() === item.toLowerCase()))
        const value = key && source[key]
        this.products = Array.isArray(value) ? value : ((value && Array.isArray(value.Items)) ? value.Items : [])
      }
      this.$nextTick(this.updateScrollbar)
    },
    updateScrollbar () {
      const el = this.$refs.tableScroll
      if (!el) return
      const hasX = el.scrollWidth > el.clientWidth
      this.scrollbars.hasX = hasX
      this.scrollbars.xSize = hasX ? (el.clientWidth / el.scrollWidth) * 100 : 100
      this.scrollbars.xOffset = hasX ? (el.scrollLeft / el.scrollWidth) * 100 : 0
      if (this.$refs.tableHeaderScroll) this.$refs.tableHeaderScroll.scrollLeft = el.scrollLeft
    },
    source () { return this.data && Array.isArray(this.data.Orders) ? this.data.Orders[0] : (Array.isArray(this.data) ? this.data[0] : this.data) },
    value (source, keys, fallback) { if (!source || typeof source !== 'object') return fallback; const key = Object.keys(source).find(k => keys.some(name => k.toLowerCase() === name.toLowerCase())); const value = key && source[key]; return value === undefined || value === null || value === '' ? fallback : value },
    field (keys, fallback) { return this.value(this.source(), keys, fallback || '处理中') },
    productField (item, keys, fallback) { return this.value(item, keys, fallback) },
    progressField (item, keys) { return this.value(item, keys, '处理中') },
    date (value) { if (!value || value === '暂无') return value; return String(value).replace('T', ' ').split('.')[0] }
  }
}
</script>
